import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Paper, IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Grid2, Typography } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import { IconTrash, IconEdit, IconEye, IconDotsVertical, IconPlus, IconSearch, IconRestore } from "@tabler/icons-react";
import axios from "axios";
import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
import { useForm } from "react-hook-form";

import StatusChip from "@components/chip/statusChip";
import ConfirmDialog from "@components/dialog/confirmDialog";
import ControlledTextField from "@components/inputs/controlledTextField";
import ControlledAutocomplete from "@components/inputs/controlledAutocomplete";
import CustomIconButton from "@components/button/customIconButton";
import ControlledDatePicker from "@components/inputs/controlledDatePicker";

import { useSnackbar } from "@context/snackbarContext";
import { useAuthentication } from "@redux/authentication/hook";

import { ACTION } from "@utils/constant";

import { AdminApiEndpoints } from "@configuration/apiEndpoints";
import { formatDate } from "@utils/formatter";

import { applyFilters, createSearchFilter, createCustomFilter, createDateRangeFilter } from "@utils/filter";

const defaultQueryFields = {
  search: "",
  // broadcastType: null,
  // status: null,
  dateFrom: "",
  dateTo: "",
};

export default function Newsletter() {
  const queryClient = useQueryClient()
  const openSnackbar = useSnackbar();
  const { user } = useAuthentication()
 
  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      search: "",
      // broadcastType: null,
      // status: null,
      dateFrom: "",
      dateTo: "",
    }
  })

  const [searchQuery, setSearchQuery] = useState(defaultQueryFields)

  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [openActionMenu, setOpenActionMenu] = useState(false);

  const [action, setAction] = useState("")
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)

  const [selectedRow, setSelectedRow] = useState(null)

  //==========================DEMO==========================
  // const isFetching = false
  // const [data, setData] = useState(DUMMY_DATA)


  const handleConfirmSubmit = () => {
    const key = "broadcastGuid";  /// Change This

    // if (action === ACTION.DELETE) {
    //   const updatedItems = data.filter((item) => item[key] !== selectedRow[key]);
    //   setData(updatedItems);
    //   setOpenConfirmDialog(false)
    // }
    // if (action === ACTION.UPDATE_STATUS){
    //   const updatedItems = data.map((item) =>
    //     item[key] === selectedRow[key] ? { ...item, statusText: item.statusText === "Active" ? "Inactive" : "Active" } : item
    //   );
    //   setData(updatedItems);
    //   setOpenConfirmDialog(false);
    // }
  }
  //==========================DEMO==========================

  const { isFetching, error, data } = useQuery({
    queryKey: ['getBroadcast'],
    queryFn: () =>
      axios.get(AdminApiEndpoints.getBroadcast),
    initialData: [],
    select: (res) => {
      const data = res?.data || [];
      return data.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn));
    },
  })

  // console.log(data)

  // const deleteCategoryMutation = useMutation({
  //   mutationFn: (id) => {
  //     return axios.delete(`${AdminApiEndpoints.deleteProductCategory}/${id}`)
  //   },
  //   onSuccess: () => {
  //     setOpenConfirmDialog(false)
  //     queryClient.invalidateQueries({ queryKey: ['getProductCategoryRecordsList'] })
  //     openSnackbar("Successfully deleted product category", "success");
  //   },
  //   onError: (err) => {
  //     setOpenConfirmDialog(false)
  //     openSnackbar("Failed to delete product category", "error");
  //   }
  // })

  // const updateCategoryStatusMutation = useMutation({
  //   mutationFn: (data) => {
  //     return axios.put(`${AdminApiEndpoints.updateProductCategoryStatus}/${data.id}`, {status: data?.status})
  //   },
  //   onSuccess: () => {
  //     setOpenConfirmDialog(false)
  //     queryClient.invalidateQueries({ queryKey: ['getProductCategoryRecordsList'] })
  //     openSnackbar("Successfully updated product category status", "success");
  //   },
  //   onError: (err) => {
  //     setOpenConfirmDialog(false)
  //     openSnackbar("Failed to update product category status", "error");
  //   }
  // })

  // const handleConfirmSubmit = () => {
  //   if (action === ACTION.DELETE) {}
  //     deleteCategoryMutation.mutate(selectedRow?.productCategoryGuid)
  //   if (action === ACTION.UPDATE_STATUS)
  //     updateCategoryStatusMutation.mutate({id: selectedRow?.productCategoryGuid, status: selectedRow?.statusText === 'Active' ? 2 : 1})
  // }

  //================================Table================================

  const handleClickStatusChip = (row) => {
    setAction(ACTION.UPDATE_STATUS);
    setSelectedRow(row);
    setOpenConfirmDialog(true);
  }

  const handleClickDelete = () => {
    setAction(ACTION.DELETE);
    setOpenConfirmDialog(true);
    setOpenActionMenu(false);
  }

  const handleClickActions = (event, row) => {
    setMenuAnchorEl(event.currentTarget);
    setOpenActionMenu(true);
    setSelectedRow(row);
  };

  const renderPopper = () => {
    return (
      <Menu
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        anchorEl={menuAnchorEl}
        open={openActionMenu}
        onClose={()=>setOpenActionMenu(false)}
      >
        <MenuItem
          component={RouterLink}
          to={`view?id=${selectedRow?.broadcastGuid}`}
        >
          <ListItemIcon>
            <IconEye size={20}/>
          </ListItemIcon>
          <ListItemText>View</ListItemText>
        </MenuItem>
        {/* <MenuItem
          component={RouterLink}
          to={`edit?id=${selectedRow?.broadcastGuid}`}
        >
          <ListItemIcon>
            <IconEdit size={20}/>
          </ListItemIcon>
          <ListItemText>Edit</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={handleClickDelete}
        >
          <ListItemIcon>
            <IconTrash size={20}/>
          </ListItemIcon>
          <ListItemText>Delete</ListItemText>
        </MenuItem> */}
      </Menu>
    );
  };

  //=====================================================================

  //================================Filter================================
        
  const handleClickSearch = (data) => {
    setSearchQuery(data)
  }

  const handleClickReset = () => {
    reset(defaultQueryFields)
    setSearchQuery(defaultQueryFields)
  }

  const filters = [
    createSearchFilter(searchQuery.search, ["title"]),
    createDateRangeFilter(searchQuery.dateFrom, searchQuery.dateTo, 'createdOn')
  ];

  const filteredData = applyFilters(data, filters);

  //======================================================================

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: "25px"}}>
      <Paper
        sx={{
          p: "20px 25px",
          boxShadow: "none",
          borderRadius: "10px",
          border: "1px solid #E5E5E5",
        }}
      >
        <Grid2 container spacing={"20px"}>
          <Grid2 size={{ xs: 12 }}>
            <Typography
              fontSize={"0.9rem"}
              color={"#202020"}
              fontWeight={600}
            >
              Search
            </Typography>
          </Grid2>

          <Grid2 size={{ lg: 6, md: 12, sm: 12, xs: 12 }}>
            <ControlledTextField 
              name="search"
              control={control}
              label="Search"
            />
          </Grid2>

          {/* <Grid2 size={{ lg: 6, md: 12, sm: 12, xs: 12 }}>
            <ControlledAutocomplete 
              name="broadcastType"
              control={control}
              label="Broadcast Type"
              options={["Email", "WhatsApp"]}
            />
          </Grid2> */}

          {/* <Grid2 size={{ lg: 6, md: 12, sm: 12, xs: 12 }}>
            <ControlledAutocomplete 
              name="status"
              control={control}
              label="Status"
              options={["Active", "Inactive"]}
            />
          </Grid2> */}

          <Grid2 size={{ lg: 3, md: 6, sm: 6, xs: 12 }}>
            <ControlledDatePicker 
              name="dateFrom"
              control={control}
              label="Date From"
            />
          </Grid2>

          <Grid2 size={{ lg: 3, md: 6, sm: 6, xs: 12 }}>
            <ControlledDatePicker 
              name="dateTo"
              control={control}
              label="Date To"
            />
          </Grid2>

          <Grid2 size={{ xs: 12 }} display={'flex'} justifyContent={"flex-end"} gap={"10px"}>
            <CustomIconButton aria-label="Reset" color="#999999" onClick={handleClickReset}>
              <IconRestore />
            </CustomIconButton>
            <CustomIconButton aria-label="Search" onClick={handleSubmit(handleClickSearch)}>
              <IconSearch />
            </CustomIconButton>
          </Grid2>
        </Grid2>
      </Paper>
      <Paper
        sx={{
          p: "0px 25px",
          boxShadow: "none",
          borderRadius: "10px",
          border: "1px solid #E5E5E5",
        }}
      >
        <DataGrid
          loading={isFetching}
          rows={filteredData}
          localeText={{ noRowsLabel: 'No records found' }}
          getRowId={(row) => row.broadcastGuid}
          columns={[
            {
              field: 'title',
              headerName: 'Title',
              flex: 1.5, minWidth: 125,
            },
            {
              field: 'broadcastType',
              headerName: 'Broadcast Type',
              flex: 1, minWidth: 125,
              sortable: false,
              valueGetter: (value) => value?.valueEng
            },
            // {
            //   field: 'broadcastDate',
            //   headerName: 'Broadcast Date',
            //   flex: 1, minWidth: 125,
            //   valueGetter: (value) => formatDate(value),
            // },
            {
              field: 'createdOn',
              headerName: 'Created On',
              flex: 1, minWidth: 125,
              valueGetter: (value) => formatDate(value),
            },
            {
              field: 'createdBy',
              headerName: 'Created By',
              flex: 1, minWidth: 125,
            },
            // {
            //   field: 'status',
            //   headerName: 'Status',
            //   flex: 1, minWidth: 100,
            //   sortable: false,
            //   renderCell: (params) => (
            //     <StatusChip  status={params.row.status.valueEng}/>
            //   ),
            // },
            {
              field: 'actions',
              headerName: 'Actions',
              sortable: false,
              renderCell: (params) => (
                <IconButton aria-label="Actions" onClick={(event) => handleClickActions(event, params.row)}>
                  <IconDotsVertical />
                </IconButton>
              ),
            },
          ]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          pageSizeOptions={[10,25,50]}
          disableRowSelectionOnClick
          disableColumnResize
          disableColumnMenu
          disableColumnSelector
          disableDensitySelector
          sx={{ border: 0 }}
        />
        {renderPopper()}
      </Paper>
      
      <ConfirmDialog 
        open={openConfirmDialog}
        onClose={()=>setOpenConfirmDialog(false)}
        onSubmit={handleConfirmSubmit}
        // loading={deleteCategoryMutation.isPending || updateCategoryStatusMutation.isPending}
        type={action === ACTION.DELETE ? "error" : "info"}
        dialogTitle={`${action} Confirmation`}
        dialogDescription={
          action === ACTION.DELETE ? 
            'Are you sure you want to delete the following broadcast?'
          : 
            `Update the following broadcast status to ${selectedRow?.statusText === "Active" ? 'Inactive' : 'Active'}?`
        }
        items={[selectedRow?.broadcastNo]}
      />
    </div>
  );
}